var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":""}},_vm._l((_vm.mods),function(mod){return _c('ModlistEntry',{key:mod.workshopId,attrs:{"mod":mod,"mutable":_vm.mutable}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }